import { memo } from "react"

// A small picture sitting between two text lines: image flows with text.
export const ImageInlineIcon = memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12Z"
        fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12Z"
        fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7C9.44772 7 9 7.44772 9 8V16C9 16.5523 9.44772 17 10 17H10.5858L13.2929 14.2929C13.6834 13.9024 14.3166 13.9024 14.7071 14.2929L15 14.5858V8C15 7.44772 14.5523 7 14 7H10ZM7 8C7 6.34315 8.34315 5 10 5H14C15.6569 5 17 6.34315 17 8V16C17 17.6569 15.6569 19 14 19H10C8.34315 19 7 17.6569 7 16V8ZM11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10Z"
        fill="currentColor" />
    </svg>
  );
})

ImageInlineIcon.displayName = "ImageInlineIcon"
